export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_GTRANSLATE_TO_UNAVAILABLE = 'SET_GTRANSLATE_TO_UNAVAILABLE';

export const SET_LOGIN_MODAL_STATE = 'SET_LOGIN_MODAL_STATE';
export const UNSET_LOGIN_MODAL_STATE = 'UNSET_LOGIN_MODAL_STATE';
export const SET_AUTH_TAB_VALUE = 'SET_AUTH_TAB_VALUE';
export const RESET_AUTH_ERRORS = 'RESET_AUTH_ERRORS';
export const CLIENT_SET_SIGN_IN_ERROR = 'CLIENT_SET_SIGN_IN_ERROR';
export const CLIENT_SET_SIGN_UP_ERROR = 'CLIENT_SET_SIGN_UP_ERROR';
export const SET_CLASSROOM_CREATED = 'SET_CLASSROOM_CREATED';
export const UNSET_CLASSROOM_CREATED = 'UNSET_CLASSROOM_CREATED';
export const SET_REPORT_FORM_OPEN = 'SET_REPORT_FORM_OPEN';
export const UNSET_REPORT_FORM_OPEN = 'UNSET_REPORT_FORM_OPEN';
export const SET_REPORT_FORM_TYPE = 'SET_REPORT_FORM_TYPE';
export const SET_REPORT_FORM_ID = 'SET_REPORT_FORM_ID';
export const SET_CLASSROOM_CREATOR_ID = 'SET_CLASSROOM_CREATOR_ID';

export const START_AUTH_LISTEN = 'START_AUTH_LISTEN';
export const AUTHENTICATED = 'AUTHENTICATED';
export const UNAUTHENTICATED = 'UNAUTHENTICATED';
export const UNVERIFIED_EMAIL = 'UNVERIFIED_EMAIL';
export const START_SIGN_UP_CALL = 'START_SIGN_UP_CALL';
export const SUCCESS_SIGNING_UP = 'SUCCESS_SIGNING_UP';
export const FAILED_SIGNING_UP = 'FAILED_SIGNING_UP';
export const START_SIGN_IN_CALL = 'START_SIGN_IN_CALL';
export const SUCCESS_SIGNING_IN = 'SUCCESS_SIGNING_IN';
export const FAILED_SIGNING_IN = 'FAILED_SIGNING_IN';
export const START_LOGOUT = 'START_LOGOUT';
export const SUCCESS_LOGOUT = 'SUCCESS_LOGOUT ';
export const FAILED_LOGOUT = 'FAILED_LOGOUT';
export const FETCHING_CLASSROOM_STATUSES = 'FETCHING_CLASSROOM_STATUSES';
export const FETCHED_CLASSROOM_STATUSES = 'FETCHED_CLASSROOM_STATUSES';
export const JOINED_CLASSROOM = 'JOINED_CLASSROOM';
export const FAILED_TO_JOIN_CLASSROOM = 'FAILED_TO_JOIN_CLASSROOM';
export const RESET_FAILED_ERROR_JOINING = 'RESET_FAILED_ERROR_JOINING';
export const CREATE_CLASSROOM_STARTED = 'CREATE_CLASSROOM_STARTED';
export const CREATED_CLASSROOM = 'CREATED_CLASSROOM';
export const FAILED_TO_CREATE_CLASSROOM = 'FAILED_TO_CREATE_CLASSROOM';
export const RESET_CLASSROOM_CREATING_STATES = 'RESET_CLASSROOM_CREATING_STATES';
export const SUCCESS_UPLOAD_AVATAR = 'SUCCESS_UPLOAD_AVATAR';
export const FAILED_UPLOAD_AVATAR = 'FAILED_UPLOAD_AVATAR';

export const FETCH_ALL_CLASSROOMS_STARTED = 'FETCH_ALL_CLASSROOMS_STARTED';
export const FETCHED_ALL_CLASSROOMS = 'FETCHED_ALL_CLASSROOMS';
export const FAILED_TO_FETCH_ALL_CLASSROOMS = 'FAILED_TO_FETCH_ALL_CLASSROOMS';
export const CLASSROOM_IS_FULL = 'CLASSROOM_IS_FULL';
export const CLASSROOM_IS_OPEN = 'CLASSROOM_IS_OPEN';
export const FETCHED_SPECIFIC_CLASSROOM = 'FETCHED_SPECIFIC_CLASSROOM';
export const FAILED_TO_FETCH_SPECIFIC_CLASSROOM = 'FAILED_TO_FETCH_SPECIFIC_CLASSROOM';
export const FORCE_START_CLASSROOM = 'FORCE_START_CLASSROOM';
export const DONE_FORCE_START_CLASSROOM = 'DONE_FORCE_START_CLASSROOM';
export const FAILED_FORCE_START_CLASSROOM = 'FAILED_FORCE_START_CLASSROOM';

export const FAILED_TO_CONNECT_ON_CHAT = 'FAILED_TO_CONNECT_ON_CHAT';
export const SUCCESSFUL_CONNECT_TO_CHAT = 'SUCCESSFUL_CONNECT_TO_CHAT';
export const SUCCESSFUL_GETTING_ALL_USER_CREDENTIALS =
  'SUCCESSFUL_GETTING_ALL_USER_CREDENTIALS';
export const FAILED_GETTING_ALL_USER_CREDENTIALS = 'FAILED_GETTING_ALL_USER_CREDENTIALS';
export const UPDATE_ONLINE_USERS_LIST = 'UPDATE_ONLINE_USERS_LIST';
export const STARTED_SENDING_MESSAGE = 'STARTED_SENDING_MESSAGE';
export const FINISHED_SENDING_MESSAGE = 'FINISHED_SENDING_MESSAGE';
export const MESSAGE_NOT_SENT = 'MESSAGE_NOT_SENT';
export const CLEAR_NOT_SENT_STATUS = 'CLEAR_NOT_SENT_STATUS';
export const FAILED_GETTING_MAIN_CHAT = 'FAILED_GETTING_MAIN_CHAT';
export const SUCCESSFUL_GETTING_MAIN_CHAT = 'SUCCESSFUL_GETTING_MAIN_CHAT';
export const SUCCESSFUL_UPDATING_MAIN_CHAT = 'SUCCESSFUL_UPDATING_MAIN_CHAT';
export const FAILED_UPDATING_MAIN_CHAT = 'FAILED_UPDATING_MAIN_CHAT';
export const CHANGE_SUB_CHAT_STATES = 'CHANGE_SUB_CHAT_STATES';
export const RECOVER_MAIN_CHAT_STATE = 'RECOVER_MAIN_CHAT_STATE';
export const STARTED_GETTING_SUB_CHAT = 'STARTED_GETTING_SUB_CHAT';
export const FAILED_GETTING_SUB_CHAT = 'FAILED_GETTING_SUB_CHAT';
export const SUCCESSFUL_GETTING_SUB_CHAT = 'SUCCESSFUL_GETTING_SUB_CHAT';
export const FAILED_UPDATING_SUB_CHAT = 'FAILED_UPDATING_SUB_CHAT';
export const SUCCESSFUL_UPDATING_SUB_CHAT = 'SUCCESSFUL_UPDATING_SUB_CHAT';
export const ON_LEAVE_CHAT_CMP = 'ON_LEAVE_CHAT_CMP';

export const STARTED_FETCHING_LECTURES = 'STARTED_FETCHING_LECTURES';
export const INITIALIZE_LECTURES = 'INITIALIZE_LECTURES';
export const STARTED_CREATING_LECTURE = 'STARTED_CREATING_LECTURE';
export const FINISHED_CREATING_LECTURE = 'FINISHED_CREATING_LECTURE';
export const FAILED_CREATING_LECTURE = 'FAILED_CREATING_LECTURE';
export const RESET_CREATING_LECTURE_DATA = 'RESET_CREATING_LECTURE_DATA';
export const SET_INIDIVIDUAL_LECTURE_DATA = 'SET_INIDIVIDUAL_LECTURE_DATA';
export const RESET_INIDIVIDUAL_LECTURE_DATA = 'RESET_INIDIVIDUAL_LECTURE_DATA';
export const GOTTEN_LECTURE_COMMENTS = 'GOTTEN_LECTURE_COMMENTS';
export const FAILED_TO_GET_LECTURE_COMMENTS = 'FAILED_TO_GET_LECTURE_COMMENTS';
export const STARTED_SENDING_LECTURE_COMMENT = 'STARTED_SENDING_LECTURE_COMMENT';
export const SENT_LECTURE_COMMENT = 'SENT_LECTURE_COMMENT';
export const FAILED_TO_SEND_LECTURE_COMMENT = 'FAILED_TO_SEND_LECTURE_COMMENT';

export const STARTED_FETCHING_ASSIGNMENTS = 'STARTED_FETCHING_ASSIGNMENTS';
export const INITIALIZE_ASSIGNMENTS = 'INITIALIZE_ASSIGNMENTS';
export const RESET_FETCHING_DATA = 'RESET_FETCHING_DATA';
export const STARTED_CREATING_ASSIGNMENT = 'STARTED_CREATING_ASSIGNMENT';
export const FINISHED_CREATING_ASSIGNMENT = 'FINISHED_CREATING_ASSIGNMENT';
export const FAILED_CREATING_ASSIGNMENT = 'FAILED_CREATING_ASSIGNMENT';
export const RESET_CREATING_ASSIGNMENT_DATA = 'RESET_CREATING_ASSIGNMENT_DATA';
export const SET_INIDIVIDUAL_ASSIGNMENT_DATA = 'SET_INIDIVIDUAL_ASSIGNMENT_DATA';
export const RESET_INIDIVIDUAL_ASSIGNMENT_DATA = 'RESET_INIDIVIDUAL_ASSIGNMENT_DATA';
export const GOTTEN_ASSIGNMENT_COMMENTS = 'GOTTEN_ASSIGNMENT_COMMENTS';
export const FAILED_TO_GET_ASSIGNMENT_COMMENTS = 'FAILED_TO_GET_ASSIGNMENT_COMMENTS';
export const STARTED_SENDING_ASSIGNMENT_COMMENT = 'STARTED_SENDING_ASSIGNMENT_COMMENT';
export const SENT_ASSIGNMENT_COMMENT = 'SENT_ASSIGNMENT_COMMENT';
export const FAILED_TO_SEND_ASSIGNMENT_COMMENT = 'FAILED_TO_SEND_ASSIGNMENT_COMMENT';
export const STARTED_FETCHING_SUBMISSIONS = 'STARTED_FETCHING_SUBMISSIONS';
export const FETCHED_SUBMISSIONS_EDUCATOR = 'FETCHED_SUBMISSIONS_EDUCATOR';
export const FETCHED_SUBMISSION_STUDENT = 'FETCHED_SUBMISSION_STUDENT';
export const FAILED_TO_FETCH_SUBMISSIONS = 'FAILED_TO_FETCH_SUBMISSIONS';
export const FINISHED_SUBMITTING_ASSIGNMENT = 'FINISHED_SUBMITTING_ASSIGNMENT';
export const RESET_SINGLE_SUBMISSION = 'RESET_SINGLE_SUBMISSION';
export const UPDATE_SUBMISSIONS = 'UPDATE_SUBMISSIONS';

export const STARTED_FETCHING_EVENTS = 'STARTED_FETCHING_EVENTS';
export const FETCHED_EVENTS = 'FETCHED_EVENTS';
export const FAILED_TO_FETCH_EVENTS = 'FAILED_TO_FETCH_EVENTS';
export const STARTED_ADDING_EVENT = 'STARTED_ADDING_EVENT';
export const ADDED_EVENT = 'ADDED_EVENT';
export const FAILED_TO_ADD_EVENT = 'FAILED_TO_ADD_EVENT';
export const EDITING_EVENT = 'EDITING_EVENT';
export const EDITED_EVENT = 'EDITED_EVENT';
export const FAILED_TO_EDIT_EVENT = 'FAILED_TO_EDIT_EVENT';
export const RESET_EVENTS_DATA = 'RESET_EVENTS_DATA';

export const STARTED_FETCHING_EDUCATORS = 'STARTED_FETCHING_EDUCATORS';
export const GOTTEN_EDUCATORS_DETAILS = 'GOTTEN_EDUCATORS_DETAILS';
export const FAILED_TO_GET_EDUCATORS = 'FAILED_TO_GET_EDUCATORS';

export const STARTED_EDITING_PROFILE = 'STARTED_EDITING_PROFILE';
export const EDITED_PROFILE = 'EDITED_PROFILE';
export const FAILED_EDITING_PROFILE = 'FAILED_EDITING_PROFILE';
export const EDIT_PROFILE_SUCCESS = 'EDIT_PROFILE_SUCCESS';
export const EDIT_PROFILE_FAILED = 'FAILED_EDITING_EXECUTION';
export const RESET_EDITING_PROFILE_STATE = 'RESET_EDITING_PROFILE_STATE';
export const STARTED_UPLOADING_AVATAR = 'STARTED_UPLOADING_AVATAR';
export const UPDATE_AVATAR_UPLOAD_PROGRESS = 'UPDATE_AVATAR_UPLOAD_PROGRESS';
export const FAILED_UPLOADING_AVATAR = 'FAILED_UPLOADING_AVATAR';
export const FINISHED_UPLOADING_AVATAR = 'FINISHED_UPLOADING_AVATAR';
export const RESET_UPLOADING_AVATAR_STATE = 'RESET_UPLOADING_AVATAR_STATE';

export const FAILED_TO_CONNECT_ON_LIVESTREAM = 'FAILED_TO_CONNECT_ON_LIVESTREAM';
export const SUCCESSFUL_CONNECT_TO_LIVESTREAM = 'SUCCESSFUL_CONNECT_TO_LIVESTREAM';
